var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-headful',{attrs:{"title":_vm.title + ' - EntwicklerHeld.de',"url":'https://platform.entwicklerheld.de' + _vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }